// extracted by mini-css-extract-plugin
module.exports = {"social-icon":"login-social-and-signin-actions_social-icon__3-SeP","signin-container":"login-social-and-signin-actions_signin-container__3lLil"};